/**
 * Product Dropdown — accordion tabs for product page content.
 * The first item can split What’s in the box / Product highlights.
 */
(function () {
  if (customElements.get('product-dropdown')) return;

  class ProductDropdown extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-pdd-item]')];
      this.splitTabs = [...this.querySelectorAll('[data-pdd-split-tab]')];
      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onSplitTabClick = this.onSplitTabClick.bind(this);

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-pdd-trigger]');
        if (trigger) trigger.addEventListener('click', this.onTriggerClick);
      });

      this.splitTabs.forEach((tab) => {
        tab.addEventListener('click', this.onSplitTabClick);
      });
    }

    disconnectedCallback() {
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-pdd-trigger]');
        if (trigger) trigger.removeEventListener('click', this.onTriggerClick);
      });

      this.splitTabs.forEach((tab) => {
        tab.removeEventListener('click', this.onSplitTabClick);
      });
    }

    onTriggerClick(event) {
      const trigger = event.currentTarget;
      const item = trigger.closest('[data-pdd-item]');
      if (!item) return;

      if (item.classList.contains('is-open')) {
        this.closeItem(item);
      } else {
        this.openItem(item);
      }
    }

    onSplitTabClick(event) {
      const tab = event.currentTarget;
      const item = tab.closest('[data-pdd-item]');
      const key = tab.getAttribute('data-pdd-split-tab');
      if (!item || !key) return;

      const tabs = [...item.querySelectorAll('[data-pdd-split-tab]')];
      const panes = [...item.querySelectorAll('[data-pdd-split-pane]')];
      const panel = item.querySelector('[data-pdd-panel]');

      tabs.forEach((el) => {
        const active = el === tab;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panes.forEach((pane) => {
        const active = pane.getAttribute('data-pdd-split-pane') === key;
        pane.classList.toggle('is-active', active);
        pane.hidden = !active;
      });

      if (panel) panel.setAttribute('aria-labelledby', tab.id);

      if (!item.classList.contains('is-open')) this.openItem(item);

      if (key === 'highlights') {
        const overview = item.querySelector('premium-build-overview');
        if (overview && typeof overview.reveal === 'function') {
          requestAnimationFrame(() => overview.reveal());
        }
      }
    }

    openItem(item) {
      item.classList.add('is-open');
      const trigger = item.querySelector('[data-pdd-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    closeItem(item) {
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-pdd-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('product-dropdown', ProductDropdown);
})();
